import {baseActionRequest} from "./Base";

export const readEntity = (
    entityName : string,
    entityId : string
) => baseActionRequest('read', entityName, entityId);

export const createEntity = (
    entityName : string,
    entityId : string
) => baseActionRequest('create', entityName, entityId);

export const updateEntity = (
    entityName : string,
    entityId : string
) => baseActionRequest('update', entityName, entityId);

export const deleteEntity = (
    entityName : string,
    entityId : string
) => baseActionRequest('delete', entityName, entityId);